import momentGenerateConfig from "rc-picker/es/generate/moment";
import generatePicker from './generatePicker';
var DatePicker = generatePicker(momentGenerateConfig);
export default DatePicker;


//////////////////
// WEBPACK FOOTER
// ./node_modules/antd/es/date-picker/index.js
// module id = 441
// module chunks = 0